/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Bill_UnavailableInputs */



/**
* | output |
* | --- |
* | "This bill is not available for this organization." |
*
* @param {Partner_Org_Bill_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_bill_unavailable = /** @type {((inputs?: Partner_Org_Bill_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Bill_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Rechnung ist für diese Organisation nicht verfügbar.")
	return /** @type {LocalizedString} */ ("This bill is not available for this organization.")
});